/**
 * @generated SignedSource<<ba779ef6b812cede154959a2e0f9172b>>
 * @relayHash 566ec581d7b46097a17ae532ccf2c747
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f596b0f9584438b830afd4ec08afdf07c7a8023da440d893cd0bf35b6e0f2caa

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraBusinessListAppQuery } from './JiraBusinessListAppQuery.graphql';

const node: PreloadableConcreteRequest<JiraBusinessListAppQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "f596b0f9584438b830afd4ec08afdf07c7a8023da440d893cd0bf35b6e0f2caa",
    "metadata": {},
    "name": "JiraBusinessListAppQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
